
<template>

	<div>

		<myframe class="mt-2" title="Сведения об объекте недвижимости" without_border>

			<biTable class="mt-4" :data="obj_desc" />

		</myframe>

		<myframe class="mt-2" title="Сведения о результатах определения кадастровой стоимости" without_border>
			<biTable class="mt-4" :data="cost_evaluation_desc">
				<template v-slot:value_params="row">
					<router-link v-if="row.data.title == 'Расчетная группа'" :to="row.data.value.url">{{ row.data.value.full_name }}</router-link>
					<template v-if="row.data.title == 'Метод определения КС / Подход'">
						<div v-for="(value, index) in row.data.value" :key="index">{{ value }}</div>
					</template>
				</template>
			</biTable>
		</myframe>

	</div>

</template>

<script>

import api from "../../../../api"
import myframe from "../../../widgets/frame"
import biTable from "../../../widgets/bi-table"

export default
{
	props :
	{
		current_version : Object,
		geojson : Object,
		object_type_reference : Object,
		category_reference : Object,
		assignation_building_reference : Object,
		assignation_type_reference : Object,
		assignation_code_reference : Object,
	},

	components :
	{
		myframe,
		biTable,
	},

	computed :
	{
		object_type()
		{
			return api.format_reference(this.object_type_reference, this.current_version.attrs.ObjectType, true)
		},

		is_parcel() { return this.current_version.attrs.ObjectType == "002001001000" },
		is_building() { return this.current_version.attrs.ObjectType == "002001002000" },
		is_flat() { return this.current_version.attrs.ObjectType == "002001003000" },
		is_construction() { return this.current_version.attrs.ObjectType == "002001004000" },
		is_uncompleted() { return this.current_version.attrs.ObjectType == "002001005000" },
		is_car_place() { return this.current_version.attrs.ObjectType == "002001009000" },

		current_cost() { return api.format_cost(this.current_version.attrs.cost) },
		current_date_valuation() { return api.format_date(this.current_version.attrs.date_valuation) },
		current_upks() { return api.format_cost(this.current_version.attrs.UPKS) },
		current_category() { return api.format_reference(this.category_reference, this.current_version.attrs.Category, true) },
		current_assignation_building() { return api.format_reference(this.assignation_building_reference, this.current_version.attrs.createBuilding, true) },

		current_assignation_flat()
		{
			return api.format_reference(this.assignation_code_reference, this.current_version.attrs.AssignationCode, true)
			// if(this.current_version.attrs.Assignation)
			// {
			// 	const assignation = this.current_version.attrs.Assignation
			// 	const code = assignation.AssignationCode
			// 	var fields = []

			// 	if(code)
			// 		fields.push(api.format_reference(this.assignation_code_reference, code, true))

			// 	if(code == "206001000000")
			// 	{
			// 		if(assignation.TotalAssets)
			// 			fields.push(assignation.TotalAssets)
			// 		else if(assignation.AuxiliaryFlat)
			// 			fields.push(assignation.AuxiliaryFlat)
			// 	}
			// 	else if(code == "206002000000")
			// 	{
			// 		if(assignation.AssignationType)
			// 			fields.push(api.format_reference(this.assignation_type_reference, assignation.AssignationType, true))
			// 		else if(assignation.SpecialType)
			// 			fields.push(assignation.SpecialType)
			// 	}

			// 	return fields.join(" / ")
			// }

			// return ""
		},
		
		current_permitted_use()
		{
			if(this.current_version.attrs.Utilization)
			{
				if(this.current_version.attrs.Utilization.LandUse)
					return this.current_version.attrs.Utilization.LandUse

				if(this.current_version.attrs.Utilization.ByDoc)
					return this.current_version.attrs.Utilization.ByDoc

				if(this.current_version.attrs.Utilization.PermittedUseText)
					return this.current_version.attrs.Utilization.PermittedUseText
			}

			return ""
		},

		current_degree_readiness()
		{
			const degree_readiness = this.current_version.attrs.DegreeReadiness

			if(degree_readiness)
				return String(degree_readiness) + " %"

			return ""
		},

		cost() { return api.format_cost(this.current_version.attrs.cost) },
		upks() { return api.format_cost(this.current_version.attrs.UPKS) },
		date_valuation() { return api.format_date(this.current_version.attrs.date_valuation) },

		obj_desc()
		{
			let rows = [
				{ title: 'Кадастровый номер', value : this.current_version.attrs.CadastralNumber },
				{ title: 'Вид объекта недвижимости', value : this.object_type },
			]

			// Строка 1

			if (this.is_parcel)
			{
				rows.push(
					{ title: 'Категория земель', value : this.current_category },
					{ title: 'Вид разрешенного использования', value : this.current_permitted_use },
				)
				this.current_version.attrs.Area && rows.push({ title: 'Площадь', value : `${this.current_version.attrs.Area} кв. м` })
			}
			else if (this.is_building)
			{
				rows.push(
					{ title: 'Наименование', value : this.current_version.attrs.Name },
					{ title: 'Назначение здания', value : this.current_assignation_building },
				)
				this.current_version.attrs.Area && rows.push({ title: 'Площадь', value : `${this.current_version.attrs.Area} кв. м` })

			}
			else if (this.is_flat)
			{
				rows.push(
					{ title: 'Наименование', value : this.current_version.attrs.Name },
					{ title: 'Назначение помещения', value : this.current_assignation_flat },
				)
				this.current_version.attrs.Area && rows.push({ title: 'Площадь', value : `${this.current_version.attrs.Area} кв. м` })

			}
			else if (this.is_construction)
			{
				rows.push(
					{ title: 'Наименование', value : this.current_version.attrs.Name },
					{ title: 'Назначение', value : this.current_version.attrs.AssignationName },
				)
				this.current_version.attrs.Area && rows.push({ title: 'Площадь', value : `${this.current_version.attrs.Area} кв. м` })

			}
			else if (this.is_uncompleted)
			{
				rows.push(
					{ title: 'Назначение ОНС', value : this.current_version.attrs.AssignationName },
					{ title: 'Степень готовности в процентах', value : this.current_degree_readiness },
				)
				this.current_version.attrs.Area && rows.push({ title: 'Площадь', value : `${this.current_version.attrs.Area} кв. м` })
			}
			else if (this.is_car_place)
			{
				this.current_version.attrs.Area && rows.push({ title: 'Площадь', value : `${this.current_version.attrs.Area} кв. м` })
				this.current_version.attrs.ParentOKS && rows.push(
					{ title: 'Вид объекта недвижимости, в котором расположено ММ', value : this.current_version.attrs.ParentOKS.ObjectType },
					{ 
						title: 'Назначение объекта недвижимости, в котором расположено ММ',
						value : `${this.current_version.attrs.ParentOKS.AssignationBuilding} ${this.current_version.attrs.ParentOKS.AssignationName}`
					},

				)
			}

			return rows
		},

		cost_evaluation_desc()
		{
			let rows = [
				{ title : 'Расчетная группа', value : { url: '/group_statistic/' + this.current_version.group.id, full_name: this.current_version.group.full_name, }, params: true, }
			]

			if (
				this.current_version.group.cost_evaluation_comparative
				|| this.current_version.group.cost_evaluation_expensive
				|| this.current_version.group.cost_evaluation_profitable
			)
			{
				let values = []

				if (this.current_version.group.cost_evaluation_comparative)
				{
					values.push(`${ this.current_version.group.cost_evaluation_comparative.type } / ${ this.current_version.group.cost_evaluation_comparative.approach}`)
				}

				if (this.current_version.group.cost_evaluation_expensive)
				{
					values.push(`${ this.current_version.group.cost_evaluation_expensive.type } / ${ this.current_version.group.cost_evaluation_expensive.approach}`)
				}

				if (this.current_version.group.cost_evaluation_profitable)
				{
					values.push(`${ this.current_version.group.cost_evaluation_profitable.type } / ${ this.current_version.group.cost_evaluation_profitable.approach}`)
				}

				rows.push({ title : 'Метод определения КС / Подход', value: values, params: true, })
			}

			rows.push(
				{ title : 'Кадастровая стоимость', value: this.cost, },
				{ title : 'УПКС', value: this.upks, },
				{ title : 'Тур', value: this.current_version.name, },
			)

			return rows
		}
	}
}
</script>
